export const searchTypeRaw = {
  PRODUCT: 'product',
  BRAND: 'brand',
};

export const searchTypes = {
  MISCELLANEOUS: 'Misc',
  POPULAR_PRODUCTS: 'Popular Products',
  HISTORY: 'history',
  TRENDING: 'trending',
  MANUAL: 'Manual',
  RECENT_SEARCH_LIST_ITEM: 'RECENT_SEARCH_LIST_ITEM',
  QUERY: 'query',
  BUYING_GUIDE: 'buying_guide',
  VOICE: 'Voice',
};

export const SEARCH_ROOT = 'search';

export const TEMPLATE_FOR_BRAND_SEARCH = ',brand_menu,brand_list,';

export const RECENT_SEARCH_LIST = 'RECENT_SEARCH_LIST';

export const LAST_VISITED_SEARCH_PAGE = 'LAST_VISITED_SEARCH_PAGE';

export const LAST_VISITED_PAGE = 'lp';

export const CHIPS_IN_SINGLE_ROW = 5;

export const SOURCE_PAGE = 'sourcePage';

export const SHOPPING_BAG = 'shoppingBag';
